import {tutorialStates} from "../data/tutorial.js";
import {getCompanyStaff, getCompanyStoryChoices} from "../models/company.js";
import {globalUser} from "./globals.js";
import {StaffMembers} from "../models/models.js";

/*
Tutorial state uses a single story choice to store data.
State name is stored in the "choice" attribute.
Tutorial state names are stored in a list.
 */

async function checkToGoToNextTutorialState(company, stateCompletedNames) {
	let currentState = (await getCompanyStoryChoices(company))[0];
	if (stateCompletedNames.includes(currentState.choice)) {
		let nextState = goToNextTutorialState(currentState);
		if (nextState === 'end_tutorial') {
			company.storyName = null;
			if (!globalUser.paid) {
				await removeTutorialPaidFeatures(company);
			}
		}
		return nextState;
	}
	return false;
}

function getNextTutorialStateName(currentState) {  // get_next_tutorial_state_name
	// Get next tutorial state based on name of current state
	let currentStateIndex = tutorialStates.indexOf(currentState.choice);
	let nextStateIndex = currentStateIndex + 1;
	if (nextStateIndex < tutorialStates.length) {
		return tutorialStates[nextStateIndex];
	}
	else {
		return null;
	}
}

function goToNextTutorialState(currentState) {
	// Move tutorial to next state if it is present
	currentState.choice = getNextTutorialStateName(currentState);
	return currentState.choice;
}

async function removeTutorialPaidFeatures(company) {
	for (let staffMember of await getCompanyStaff(company)) {
		await StaffMembers.remove(staffMember);
	}
}

export {checkToGoToNextTutorialState}